import { graphqlOperation } from "aws-amplify";
import { DateTime } from "luxon";
import GraphQLAPI from "@aws-amplify/api-graphql";
import Decimal from "decimal.js";
import { OrderTicketDetailEntity } from "@goodfill/domain-entities";
import {
  OrderDirection,
  BondPriceNominal,
  BalanceAccountId,
  Amount,
  TradeTicketId,
} from "@goodfill/domain-properties";
import {
  CreateOrderTicketWithFundsReservationInput,
  createOrderTicketWithFundsReservation,
  OrderTicket,
  orderTicketDetailApiToModel,
  createAwsDateTimeFromDateTime,
} from "@goodfill/models-typescript";
import { GoodfillTransactionCommission } from "@goodfill/domain-math";
import { PricedBond } from "../../../bonds/PricedBond";

const PRECISION_MUCH_BIGGER = 30;

export async function createOrderBackendCall(
  bond: Pick<PricedBond, "bondIdCusip" | "minimumPiece">,
  price: BondPriceNominal,
  moneyBalanceAccountId: BalanceAccountId,
  faceAmount: Amount,
  isAllOrNothing: boolean,
  loadedYield: Decimal,
  rateCommission: GoodfillTransactionCommission,
  isImmediate: boolean,
  expirationDate: DateTime | null,
  direction: OrderDirection,
  closingTradeTicketId: TradeTicketId | null,
): Promise<OrderTicketDetailEntity> {
  const input: CreateOrderTicketWithFundsReservationInput = {
    direction,
    moneyBalanceAccountId: `${moneyBalanceAccountId}`,
    bondId: `${bond.bondIdCusip}`,
    minimumFillSize: (isAllOrNothing ? faceAmount : bond.minimumPiece.amount).toFixed(0),
    faceAmount: faceAmount.toFixed(0),
    bondPrice: price.toFixed(PRECISION_MUCH_BIGGER),
    commission: {
      // Todo: Hardcoded 2 places works for most of the currencies, but in the future it should be solved differently.
      //       For example some Arab currencies has 3 decimal places (and Bitcoin has 8).
      amount: rateCommission.commissionAmount.amount.toFixed(2),
      rate: rateCommission.commissionRate.toFixed(PRECISION_MUCH_BIGGER),
    },
    loadedYield: loadedYield.toFixed(PRECISION_MUCH_BIGGER),
    isImmediate,
    expiresAt: expirationDate != null ? createAwsDateTimeFromDateTime(expirationDate) : null,
    closingTradeTicketId: closingTradeTicketId != null ? `${closingTradeTicketId}` : null,
  };
  const operation = graphqlOperation(createOrderTicketWithFundsReservation, {
    input,
  });
  const result = (await GraphQLAPI.graphql(operation)) as {
    data: { createOrderTicketWithFundsReservation: OrderTicket };
  };

  return orderTicketDetailApiToModel(result.data.createOrderTicketWithFundsReservation);
}
